import debug from 'bows';
import debounce from './_debounce';

const log = debug('author-grid');

export default class {
	constructor(node, opts) {
		this.node = node;
		this.opts = Object.assign({
			activeClass        : 'author-grid__group--active',
			anchors            : '.author-grid__anchor',
			authors            : '.author-grid__author',
			debounce           : 500,
			filteredAuthorClass: 'author-grid__author--match',
			filteredClass      : 'author-grid--filtered',
			form               : '.author-grid__search',
			groups             : '.author-grid__group',
			search             : '.author-grid__search-input',
		}, opts);

		this.active   = false;
		this.filtered = false;
		this.search   = this.node.querySelector(this.opts.search);
		this.form     = this.node.querySelector(this.opts.form);
		this.anchors  = Array.from(this.node.querySelectorAll(this.opts.anchors));
		this.groups   = {};
		this.authors  = Array.from(this.node.querySelectorAll(this.opts.authors)).map((author) => {
			// build an array of no-whitespace text to search against with it's node
			return {
				text: author.textContent.replace(/\s+/g, '').replace(/[^a-zA-Z]/g, '').toLowerCase(), // something fuzzy-ish to match
				node: author
			}
		});

		Array.from(this.node.querySelectorAll(this.opts.groups)).forEach((group) => {
			if ( group.id ) {
				this.groups[group.id] = group;
			}
		});

		this.defaultGroup = Object.keys(this.groups).shift();

		// need this in case it's filtered and they click the anchor that matches the window hash (onhashchange doens't pick it up)
		const sameAnchorCheck = (e) => {
			log('sameAnchorCheck', e.target.hash);
			if (e.target.hash === window.location.hash && this.groups[window.location.hash]) {
				this.unfilter().activate(e.target.hash);
			}
		}

		this.anchors.forEach((anchor) => anchor.addEventListener('click', sameAnchorCheck ));
		this.form.addEventListener('submit', (e) => e.preventDefault());
		this.search.addEventListener('keypress', debounce( this.route.bind(this), this.opts.debounce ) );
		window.addEventListener('hashchange', () => {
			log('hashchange');
			return this.unfilter().route();
		});

		return this.route();
	}

	activate(groupId) {
		log('activate', groupId);

		if ( this.active && this.groups[this.active] ) {
			// only remove the class if one is active
			this.groups[this.active].classList.remove(this.opts.activeClass);
		}

		this.active = groupId;

		if ( this.active !== false ) {
			// activate the index if we have one
			this.groups[this.active].classList.add(this.opts.activeClass);
		} else if ( this.filtered ) {
			// add all active when filtering by search
			Object.keys(this.groups).forEach((id) => this.groups[id].classList.add(this.opts.activeClass) );
		}

		return this;
	}

	filter(str) {
		str = str.toLowerCase().replace(/\s+/g, '');
		this.filtered = true;
		this.node.classList.add(this.opts.filteredClass);
		this.activate(false);

		this.authors.forEach((author) => {
			if ( author.text.indexOf(str) > -1 ) {
				author.node.classList.add(this.opts.filteredAuthorClass);
			} else {
				author.node.classList.remove(this.opts.filteredAuthorClass);
			}
		});

		return this;
	}

	unfilter() {
		log('unfilter');
		this.filtered = false;

		// remove the filtered class from the root node
		this.node.classList.remove(this.opts.filteredClass);
		// remove the matched class from each author
		this.authors.forEach((author) => author.node.classList.remove(this.opts.filteredAuthorClass));
		// remove the filtered alpha group
		Object.keys(this.groups).forEach((id) => this.groups[id].classList.remove(this.opts.activeClass) );

		// clear the search
		if ( this.search.value ) {
			this.search.value = '';
		}

		return this;
	}

	route() {
		// the search has a value
		if ( this.search.value ) {
			log('route', this.search.value);
			return this.filter(this.search.value);
		}

		if ( this.filtered ) {
			this.unfilter();
		}

		// an anchor matches url hash
		if ( window.location.hash && this.groups[window.location.hash] ) {
			log('route', window.location.hash);
			return this.activate(window.location.hash);
		}

		// default to the first anchor hash
		log('route', 'default');
		return this.activate(this.defaultGroup);
	}
}
